import { jsx } from "react/jsx-runtime";
import {
  createElement,
  forwardRef
} from "react";
const FORWARDED_NEXT_DYNAMIC_REF_KEY = "__forwarded_next_dynamic_ref__";
function saveForwardedRef(props, ref) {
  return { ...props, [FORWARDED_NEXT_DYNAMIC_REF_KEY]: ref };
}
function loadForwardedRef({
  [FORWARDED_NEXT_DYNAMIC_REF_KEY]: ref,
  ...props
}) {
  return { ...props, ref };
}
function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}
function forwardNextDynamicRef(nextDynamicThunk) {
  const Dynamic = nextDynamicThunk(
    (loaderComponent) => loaderComponent.then((moduleOrComponent) => ({
      __esModule: true,
      default: (props) => createElement(resolve(moduleOrComponent), loadForwardedRef(props))
    }))
  );
  return forwardRef((props, ref) => /* @__PURE__ */ jsx(Dynamic, { ...saveForwardedRef(props, ref) }));
}
export {
  forwardNextDynamicRef
};
//# sourceMappingURL=dynamic.js.map